/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Household } from '../models/Household';
import type { HouseholdPerson } from '../models/HouseholdPerson';
import type { HouseholdsAndPersons } from '../models/HouseholdsAndPersons';
import type { OpenApiInteger } from '../models/OpenApiInteger';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class HouseholdsService {

    /**
     * @returns Household Households for current user
     * @throws ApiError
     */
    public static getHouseholds(): CancelablePromise<Array<Household>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/households',
            errors: {
                401: `Unauthorized`,
            },
        });
    }

    /**
     * @param householdId
     * @returns HouseholdPerson Household persons for current user
     * @throws ApiError
     */
    public static getHouseholdPersons(
        householdId: OpenApiInteger,
    ): CancelablePromise<Array<HouseholdPerson>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/households/{householdId}/household-persons',
            path: {
                'householdId': householdId,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
    }

    /**
     * @returns HouseholdsAndPersons Households and persons for current user
     * @throws ApiError
     */
    public static getHouseholdsAndPersons(): CancelablePromise<HouseholdsAndPersons> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/households-and-persons',
            errors: {
                401: `Unauthorized`,
            },
        });
    }

}
